import './page/filter-map-list';

Shopware.Module.register('topdata-es-filter-map', {
    type: 'plugin',
    name: 'Filter map',
    title: 'TopdataEnhancedSearchSW6.topdata-es-filter-map.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-filter-map.description',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-filter-map-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-filter-map-list',
        label: 'TopdataEnhancedSearchSW6.topdata-es-filter-map.listTitle',
        color: '#189eff',
        path: 'topdata.es.filter.map.list',
        parent: 'topdata-es',
    }],
});